module.exports = __webpack_public_path__ + "media/svg-new/logoMini-91fb960b.svg";